const API_BASE = import.meta.env.VITE_API_URL || ''

export async function apiFetch(path: string, options: RequestInit = {}) {
  const token = localStorage.getItem('digsafe_admin_token')
  
  const headers: Record<string, string> = {
    ...options.headers as Record<string, string>,
  }
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json'
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  })

  if (response.status === 401) {
    localStorage.removeItem('digsafe_admin_token')
    window.location.href = '/login'
    throw new Error('Unauthorized')
  }

  return response.json()
}
